// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import CheckIcon from "@mui/icons-material/Check";
import "./HomeBannerSwiper.css";
// import required modules
import { Autoplay, Pagination } from "swiper/modules";
import CloseIcon from "@mui/icons-material/Close";
import petCt from "../../assets/images/home-page/CarouselImages/pet_Ct.mp4";
import petCt_m from "../../assets/images/home-page/CarouselImages/pet_Ct mobile size.mp4";
import cardiac from "../../assets/images/home-page/CarouselImages/cardiac.jpg";
// import womenimaging from "../../assets/images/home-page/CarouselImages/Sequence 05.mp4";
import womenimaging from "../../assets/images/home-page/CarouselImages/mammograpgy-01.jpg";
import vascular from "../../assets/images/home-page/CarouselImages/vascular.jpg";
import mri from "../../assets/images/home-page/CarouselImages/mri_large.mp4";
import dti from "../../assets/images/home-page/CarouselImages/dti.jpg";
import lung from "../../assets/images/home-page/CarouselImages/lung_.png";
import personalinjury from "../../assets/images/home-page/CarouselImages/personal.jpg";
import poster_women from "../../assets/images/home-page/CarouselImages/poster_women.jpg";
import cardiac_m from "../../assets/images/home-page/CarouselImages/cta.jpg";
import womenimaging_m from "../../assets/images/home-page/CarouselImages/mammograpgy-01 (1).jpg";
import vascular_m from "../../assets/images/home-page/CarouselImages/vascularmobile.jpg";
import mri_m from "../../assets/images/home-page/CarouselImages/mri_small.mp4";
import dti_m from "../../assets/images/home-page/CarouselImages/dtimobile.jpg";
import personalinjury_m from "../../assets/images/home-page/CarouselImages/personal-m.jpg";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Link } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
export default function HomeBannerSwiper() {
  const breakpoints = {
    0: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 1.2,
    },
    1536: {
      slidesPerView: 1.2,
    },
    1600: {
      slidesPerView: 1.5,
    },
  };
  const swiperRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [activeService, setActiveService] = useState(null);
  const handleOpen = (key) => {
    setActiveService(servicesData[key]);
    setOpen(true);
    if (swiperRef.current?.autoplay) {
      swiperRef.current.autoplay.stop();
      swiperRef.current.allowTouchMove = false;
    }
  };
  const handleClose = () => {
    setOpen(false);
    if (swiperRef.current?.autoplay) {
      swiperRef.current.autoplay.start();
      swiperRef.current.allowTouchMove = true;
    }
  };
  useEffect(() => {
    if (!open && swiperRef.current) {
      // Force swiper to fully reset autoplay
      swiperRef.current.autoplay.stop();

      setTimeout(() => {
        swiperRef.current.autoplay.start();
        swiperRef.current.update();
      }, 300); // 👈 important delay
    }
  }, [open]);

  const servicesData = {
    petCt: {
      id: 1,
      title: "PET-CT for Cancer & Neurology",
      tagline: "Precision where it matters most.",
      focusline: "",
      focuslinetwo: "Used for:",
      items: [
        "Oncology PET-CT",
        "PSMA PET-CT for prostate cancer",
        "Brain PET-CT for Alzheimer’s disease",
      ],
      features: [
        "Early detection",
        "Accurate staging",
        "Treatment response monitoring",
      ],

      notes:
        "Backed by national standards and evidence-based imaging protocols.",
    },

    mri: {
      id: 2,
      title: "MRI",
      tagline: "Powerful. Quiet. Open. Intelligent.",
      items: ["Wide-Bore High-Field 1.5 T MRI", "Open & Bariatric MRI"],
      features: [
        "Claustrophobic patient friendly",
        "Bariatric support",
        "Faster exams",
        "AI-enhanced image quality comparable to traditional high-field systems",
      ],
      focusline: "",
      focuslinetwo: "Designed for:",

      notes: "The result: comfort without compromise.",
    },

    cardiacImaging: {
      id: 3,
      title: "Cardiac Imaging",
      tagline: "See heart disease-before symptoms appear.",
      items: [
        "Coronary CT Angiography (CTA)",
        "AI-assisted plaque analysis/FFR",
        "Non-invasive heart imaging",
      ],
      features: [
        "Evaluate coronary artery disease",
        "Guide preventive care",
        "Reduce unnecessary invasive procedures",
      ],
      focusline: "",
      focuslinetwo: "Used to:",
    },

    lungCancerScreening: {
      id: 4,
      title: "Lung Cancer Screening",
      tagline: "Early detection saves lives.",
      items: [
        "Low-dose CT",
        "160-slice CT technology",
        "Optimized for minimal radiation exposure",
      ],

      focusline: "",
      notes: "Recommended for eligible patients based on national guidelines.",
    },

    womensImaging: {
      id: 5,
      title: "Women’s Imaging",
      tagline: "Confidence through clarity.",
      items: [
        "3D Mammography (Tomosynthesis)",
        "Breast Ultrasound",
        "Breast MRI",
      ],
      focusline: "",
      notes: "Focused on early detection, accuracy, and compassionate care.",
    },

    vascularUltrasound: {
      id: 6,
      title: "Vascular & Preventive Ultrasound",
      tagline: "Information that empowers.",
      items: [
        "Carotid artery screening",
        "Abdominal aortic aneurysm screening",
        "Venous and arterial Doppler studies",
      ],
      focusline: "",
      notes: "Non-invasive. No radiation. Actionable insights.",
    },

    personalInjuryImaging: {
      id: 7,
      title: "Personal Injury Imaging",
      tagline: "Clarity after trauma. Evidence you can trust.",
      items: [
        "Motor vehicle accident imaging",
        "Personal injury and PIP cases",
        "Neurologic and spinal trauma",
      ],
      focusline:
        "Citrus Diagnostic Center is a regional leader in imaging for:",

      notes: "Trusted imaging for injury-related cases.",
    },

    tbiImaging: {
      id: 8,
      title: "Traumatic Brain Injury (TBI)",
      tagline:
        "Advanced neuroimaging protocols designed to detect injuries that conventional imaging may miss",
      items: [
        "High-resolution Brain MRI",
        "Diffusion Tensor Imaging (DTI) for white matter injury",
        "Evidence-based neurotrauma protocols",
      ],
      features: [
        "Concussion",
        "Post-concussive symptoms",
        "Cognitive and neurologic deficits",
      ],
      focusline: "",
      focuslinetwo: "Used to evaluate:",
      notes: "Evidence-based neurotrauma imaging protocols.",
    },
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          className:
            "3xl:w-[50vw] 3xl:h-[65vh] xl:w-[60vw] xl:h-[80vh] max-w-none bg-black/60",
        }}
      >
        <DialogContent className="bg-black border relative rounded-2xl border-[#ffffff3d] flex justify-center items-center text-white overflow-auto p-3 2xl:p-10">
          <div className="w-full md:w-[90%] pt-4 font-robout">
            {activeService && (
              <>
                <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal text-center mb-2 ">
                  {activeService.title}
                </h2>
                <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium text-base text-center  md:mb-8 md:px-6 px-2">
                  {activeService.tagline}
                </h3>

                {/* GRID START */}
                <div className="grid md:grid-cols-2 grid-cols-1 align-middle content-center gap-5 lg:gap-10 my-1  md:my-8">
                  {/* LEFT COLUMN */}
                  <div className="flex flex-col items-start ">
                    <h3 className="min-h-[20px] text-lg font-bold mb-4">
                      {activeService.focusline}
                    </h3>

                    {activeService.items && (
                      <ul className="space-y-2">
                        {activeService.items.map((item, i) => (
                          <li
                            key={i}
                            className="flex flex-row gap-2 items-center text-[#cccccc]  text-[16px] leading-[1.4em] font-medium"
                          >
                            <CheckIcon
                              fontSize="10px"
                              className="text-base text-[#bf9c5e]"
                            />{" "}
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  {/* RIGHT COLUMN */}
                  <div className="flex flex-col items-start ">
                    <h3 className="min-h-[20px] text-[#f5f5f5]  text-[16px] leading-[1.4em] font-normal mb-4">
                      {activeService.focuslinetwo}
                    </h3>

                    {activeService.features && (
                      <ul className=" space-y-2">
                        {activeService.features.map((item, i) => (
                          <li
                            key={i}
                            className="flex flex-row gap-2 items-center text-[#cccccc]  text-[16px] leading-[1.4em] font-medium"
                          >
                            <CheckIcon
                              fontSize="10px"
                              className="text-base text-[#bf9c5e]"
                            />{" "}
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
                {/* GRID END */}

                <p className="mt-6 opacity-95 min-h-4 text-[#cccccc]  text-[16px] leading-[1.4em] font-medium text-center">
                  {activeService.notes}
                </p>

                <div className="flex justify-center my-6">
                  <Link
                    to="/services"
                    className="px-8 py-2 rounded-3xl bg-white text-[14px] lg:text-[16px] leading-[1.4em] text-black font-normal hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-200"
                  >
                    View All Services
                  </Link>
                </div>
              </>
            )}
          </div>

          {/* CLOSE BUTTON */}
          <div className="absolute md:top-4 md:right-4 top-1 right-1">
            <button
              onClick={handleClose}
              className="flex justify-center items-center w-10 h-10 bg-[#6b6b6b] text-white rounded-full opacity-85 hover:opacity-100 transition"
            >
              <CloseIcon />
            </button>
          </div>
        </DialogContent>
      </Dialog>

      <div className="flex justify-center flex-col gap-10 items-center relative top-0 font-robout xl:top-24 mb-10 xl:mb-44">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          breakpoints={breakpoints}
          spaceBetween={15}
          centeredSlides={true}
          loop={true}
          pagination={{
            el: ".custom-swiper-pagination",
            clickable: true,
          }}
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper custom-swiper  h-[450px]  md:h-[650px]"
        >
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full overflow-hidden ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {/* <img
                  src={petCt}
                  alt="carousel_img"
                  className="w-full h-full lg:block hidden object-cover pointer-events-none"
                /> */}
                    <video
                  className="w-full h-full object-cover xl:block hidden pointer-events-none" title="PET-CT for Cancer & Neurology"
                  autoPlay={true}
                  loop
                  muted
                  playsInline
                >
                  <source
                    src={petCt}
                    type="video/mp4"
                    className="w-full h-full object-cover"
                  />
                </video>
                <video
                  className="w-full h-full object-cover xl:hidden block pointer-events-none"
                  autoPlay={true}
                  loop
                  muted
                  playsInline title="PET-CT for Cancer & Neurology"
                >
                  <source
                    src={petCt_m}
                    type="video/mp4"
                    className="w-full h-full object-cover"
                  />
                </video>
               
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] brightness-200 text-[#f5f5f5] font-normal py-2">
                    PET-CT for Cancer & Neurology
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Precision where it matters most.
                  </h3>
                  <button
                    onClick={() => handleOpen("petCt")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal  text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full bg-black p-5 ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <video
                  className="w-full h-full object-cover xl:block hidden pointer-events-none"
                  autoPlay={true}
                  loop
                  muted
                  playsInline title="MRI (Magnetic Resonance Imaging)"
                >
                  <source
                    src={mri}
                    type="video/mp4"
                    className="w-full h-full object-cover"
                  />
                </video>
                <video
                  className="w-full h-full object-cover xl:hidden block pointer-events-none"
                  autoPlay={true}
                  loop
                  muted
                  playsInline title="MRI (Magnetic Resonance Imaging)"
                >
                  <source
                    src={mri_m}
                    type="video/mp4"
                    className="w-full h-full object-cover"
                  />
                </video>
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5">
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    MRI (Magnetic Resonance Imaging)
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Powerful. Quiet. Open. Intelligent.
                  </h3>
                  <button
                    onClick={() => handleOpen("mri")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <img
                  src={cardiac}
                  alt="Cardiac Imaging"
                  className="w-full h-full xl:block hidden object-cover pointer-events-none"
                />
                <img
                  src={cardiac_m}
                  alt="Cardiac Imaging"
                  className=" h-full max-w-md mx-auto  xl:hidden block object-cover pointer-events-none"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Cardiac Imaging
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    See heart disease-before symptoms appear.
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("cardiacImaging")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative flex justify-center p-3 bg-black  items-center h-full ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <img
                  src={lung}
                  alt="Lung Cancer Screening"
                  className="object-cover lg:w-auto w-[280px] h-[250px] md:w-auto md:h-96 xl:h-full pointer-events-none m-2"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Lung Cancer Screening
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Early detection saves lives.
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("lungCancerScreening")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
              
                  <img
                  src={womenimaging}
                  alt=" Women’s Imaging"
                  className="w-full h-full object-cover  xl:block hidden pointer-events-none"
                />
                <img
                  src={womenimaging_m}
                  alt=" Women’s Imaging"
                  className="w-full h-full object-cover sm:max-w-xl mx-auto xl:hidden block pointer-events-none"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Women’s Imaging
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Confidence through clarity.
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("womensImaging")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <img
                  src={vascular}
                  alt=" Vascular & Preventive Ultrasound"
                  className="w-full h-full object-cover xl:block hidden pointer-events-none"
                />
                <img
                  src={vascular_m}
                  alt=" Vascular & Preventive Ultrasound"
                  className=" h-full object-cover  max-w-md mx-auto xl:hidden block pointer-events-none"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Vascular & Preventive Ultrasound
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Information that empowers
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("vascularUltrasound")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <img
                  src={personalinjury}
                  alt="Personal Injury Imaging"
                  className="w-full h-full object-cover xl:block hidden pointer-events-none"
                />
                <img
                  src={personalinjury_m}
                  alt="Personal Injury Imaging"
                  className="w-full h-full object-cover xl:hidden block pointer-events-none"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Personal Injury Imaging
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Clarity after trauma. Evidence you can trust.
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("personalInjuryImaging")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white font-normal text-[16px] leading-[1.4em] text-black hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive }) => (
              <div
                className={`lg:w-full w-11/12 relative h-full  ${
                  isActive ? "border-[1px] border-[#4d4d4d]" : ""
                } transition-transform duration-500`}
              >
                {" "}
                <img
                  src={dti}
                  alt="Traumatic Brain Injury (TBI)"
                  className="w-full h-full object-cover xl:block hidden pointer-events-none"
                />
                <img
                  src={dti_m}
                  alt="Traumatic Brain Injury (TBI)"
                  className="w-full h-full object-cover xl:hidden block pointer-events-none"
                />
                <div className="lg:bottom-2 bottom-1 absolute left-0 w-full text-left px-6 lg:px-20 lg:pt-10 py-2.5 ">
                  {" "}
                  <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal py-2">
                    Traumatic Brain Injury (TBI)
                  </h2>
                  <h3 className="text-[#cccccc]  text-[16px] leading-[1.4em] font-medium">
                    Advanced neuroimaging protocols designed to detect injuries
                    that conventional imaging may miss.
                  </h3>{" "}
                  <button
                    onClick={() => handleOpen("tbiImaging")}
                    className="px-8 py-2 rounded-3xl my-4 bg-white text-black  text-[16px] leading-[1.4em] font-normal hover:bg-black hover:border border border-[#ffffff5d] hover:text-white transition-all hover:duration-200"
                  >
                    View
                  </button>
                </div>
              </div>
            )}
          </SwiperSlide>
        </Swiper>
        <div className="custom-swiper-pagination w-full flex justify-center items-center"></div>
        <div className="xl:w-3/5 flex flex-col justify-center items-center text-center py-10">
          <p className="w-full xl:w-[60%] mx-auto  px-4  md:px-0 ">
            Comprehensive imaging services also include CT, nuclear medicine,
            ultrasound, digital X-ray, echocardiography, and bone density
            scanning.
          </p>
          <div className="flex justify-center items-center p-2 mt-10">
            <Link
              to="/services"
              className="px-8 py-2.5 rounded-3xl bg-white font-normal text-black text-[16px] leading-[1.4em] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-200"
            >
              View All Services
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
